import React from 'react'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import MapaFinanceiroFormNotas from './MapaFinanceiroFormNotas'

const MapaFinanceiroForm = ({ values, handleChange, handleSubmit }) => {
    
    return (
        <DivForm>
            <MapaFinanceiroFormNotas
                values={values}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
            />
        </DivForm>
    )
}

export default MapaFinanceiroForm